import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, withModifiers as _withModifiers, vShow as _vShow, withDirectives as _withDirectives, Transition as _Transition, withCtx as _withCtx, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "content-section" }
const _hoisted_2 = { class: "card-body" }
const _hoisted_3 = { class: "row align-items-center" }
const _hoisted_4 = { class: "col-md-3" }
const _hoisted_5 = { class: "card-img" }
const _hoisted_6 = ["src"]
const _hoisted_7 = {
  key: 0,
  class: "text-center"
}
const _hoisted_8 = { key: 0 }
const _hoisted_9 = /*#__PURE__*/_createTextVNode(" dagar till. ")
const _hoisted_10 = { key: 1 }
const _hoisted_11 = /*#__PURE__*/_createTextVNode(" dagar till. ")
const _hoisted_12 = {
  key: 2,
  class: "text-danger"
}
const _hoisted_13 = /*#__PURE__*/_createElementVNode("div", {
  style: {"height":"20px"},
  class: "row"
}, null, -1)
const _hoisted_14 = {
  key: 0,
  class: "col-md-8"
}
const _hoisted_15 = { class: "row mb-1" }
const _hoisted_16 = /*#__PURE__*/_createElementVNode("div", { class: "col-6 text-end" }, "Lånebelopp", -1)
const _hoisted_17 = { class: "col-6" }
const _hoisted_18 = {
  key: 0,
  class: "row mb-1"
}
const _hoisted_19 = /*#__PURE__*/_createElementVNode("div", { class: "col-6 text-end" }, "Varav privatlån", -1)
const _hoisted_20 = { class: "col-6" }
const _hoisted_21 = { class: "row mb-1" }
const _hoisted_22 = /*#__PURE__*/_createElementVNode("div", { class: "col-6 text-end" }, "Månadskostnad", -1)
const _hoisted_23 = { class: "col-6" }
const _hoisted_24 = { class: "row mb-1" }
const _hoisted_25 = /*#__PURE__*/_createElementVNode("div", { class: "col-6 text-end" }, "Nominell ränta", -1)
const _hoisted_26 = { class: "col-6" }
const _hoisted_27 = { class: "row mb-1" }
const _hoisted_28 = /*#__PURE__*/_createElementVNode("div", { class: "col-6 text-end" }, "Effektiv ränta", -1)
const _hoisted_29 = { class: "col-6" }
const _hoisted_30 = { class: "row mb-1" }
const _hoisted_31 = /*#__PURE__*/_createElementVNode("div", { class: "col-6 text-end" }, "Amortering", -1)
const _hoisted_32 = { class: "col-6" }
const _hoisted_33 = {
  key: 0,
  class: "card-content"
}
const _hoisted_34 = { class: "row mb-1" }
const _hoisted_35 = /*#__PURE__*/_createElementVNode("div", { class: "col-6 text-end" }, "Ränta", -1)
const _hoisted_36 = { class: "col-6" }
const _hoisted_37 = {
  key: 0,
  class: "row mb-1"
}
const _hoisted_38 = /*#__PURE__*/_createElementVNode("div", { class: "col-6 text-end" }, "Månadskostnad vid kalkylränta", -1)
const _hoisted_39 = { class: "col-6" }
const _hoisted_40 = { class: "row mb-1" }
const _hoisted_41 = /*#__PURE__*/_createElementVNode("div", { class: "col-6 text-end" }, "Bindningstid", -1)
const _hoisted_42 = { class: "col-6" }
const _hoisted_43 = { class: "row mb-1" }
const _hoisted_44 = /*#__PURE__*/_createElementVNode("div", { class: "col-6 text-end" }, "Uppläggningsavgift", -1)
const _hoisted_45 = { class: "col-6" }
const _hoisted_46 = { class: "row mb-1" }
const _hoisted_47 = /*#__PURE__*/_createElementVNode("div", { class: "col-6 text-end" }, "Aviavgift", -1)
const _hoisted_48 = { class: "col-6" }
const _hoisted_49 = {
  key: 1,
  class: "col-md-1"
}
const _hoisted_50 = {
  key: 0,
  class: "btn btn-sm btn-outline"
}
const _hoisted_51 = /*#__PURE__*/_createElementVNode("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "16",
  height: "16",
  fill: "currentColor",
  class: "bi bi-chevron-down",
  viewBox: "0 0 16 16"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    "fill-rule": "evenodd",
    d: "M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708z"
  })
], -1)
const _hoisted_52 = [
  _hoisted_51
]
const _hoisted_53 = {
  key: 1,
  class: "btn btn-sm btn-outline"
}
const _hoisted_54 = /*#__PURE__*/_createElementVNode("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "16",
  height: "16",
  fill: "currentColor",
  class: "bi bi-chevron-up",
  viewBox: "0 0 16 16"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    "fill-rule": "evenodd",
    d: "M7.646 4.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1-.708.708L8 5.707l-5.646 5.647a.5.5 0 0 1-.708-.708l6-6z"
  })
], -1)
const _hoisted_55 = [
  _hoisted_54
]
const _hoisted_56 = {
  key: 2,
  class: "col-md-7 offset-md-1"
}
const _hoisted_57 = { class: "col-lg-9 offset-lg-3" }
const _hoisted_58 = { class: "card-content" }
const _hoisted_59 = {
  key: 0,
  class: "pt-3 mt-1"
}
const _hoisted_60 = /*#__PURE__*/_createElementVNode("div", { class: "row" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "col-sm-9" })
], -1)
const _hoisted_61 = [
  _hoisted_60
]
const _hoisted_62 = {
  key: 1,
  class: "pt-3 mt-1"
}
const _hoisted_63 = /*#__PURE__*/_createElementVNode("div", { class: "row" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "col-sm-9" })
], -1)
const _hoisted_64 = [
  _hoisted_63
]
const _hoisted_65 = {
  key: 2,
  class: "border-top border-light pt-3 mt-3"
}
const _hoisted_66 = { class: "row" }
const _hoisted_67 = { class: "col-lg-4 offset-lg-0 col-md-6 offset-md-3 d-grid my-3" }
const _hoisted_68 = {
  key: 3,
  class: "border-top border-light pt-3 mt-3"
}
const _hoisted_69 = /*#__PURE__*/_createElementVNode("h3", { class: "offer-title" }, " Räntesatser vid olika bindningstider ", -1)
const _hoisted_70 = { class: "table-responsive" }
const _hoisted_71 = { class: "table table-borderless table-striped" }
const _hoisted_72 = /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", null, "Bindningstid"),
    /*#__PURE__*/_createElementVNode("th", null, "Ränta innan rabatt"),
    /*#__PURE__*/_createElementVNode("th", null, "Rabatt"),
    /*#__PURE__*/_createElementVNode("th", null, "Ränta efter rabatt")
  ])
], -1)
const _hoisted_73 = {
  key: 4,
  class: "border-top border-light pt-3 mt-3"
}
const _hoisted_74 = /*#__PURE__*/_createElementVNode("h3", { class: "offer-title" }, " Räntesatser vid olika bindningstider ", -1)
const _hoisted_75 = { class: "table-responsive" }
const _hoisted_76 = { class: "table table-borderless table-striped" }
const _hoisted_77 = /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", null, "Bindningstid"),
    /*#__PURE__*/_createElementVNode("th", null, "Ränta")
  ])
], -1)
const _hoisted_78 = {
  key: 5,
  class: "border-top border-light pt-3 mt-3"
}
const _hoisted_79 = /*#__PURE__*/_createElementVNode("h3", { class: "offer-title" }, "Om lånet", -1)
const _hoisted_80 = { class: "offer-description" }
const _hoisted_81 = {
  key: 6,
  class: "border-top border-light pt-3 mt-3"
}
const _hoisted_82 = /*#__PURE__*/_createElementVNode("h3", { class: "offer-title" }, "Om banken", -1)
const _hoisted_83 = { class: "offer-description" }
const _hoisted_84 = { key: 0 }
const _hoisted_85 = /*#__PURE__*/_createTextVNode(" Läs mer ")
const _hoisted_86 = /*#__PURE__*/_createElementVNode("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "16",
  height: "16",
  fill: "currentColor",
  class: "bi bi-caret-down-fill",
  viewBox: "0 0 16 16"
}, [
  /*#__PURE__*/_createElementVNode("path", { d: "M7.247 11.14 2.451 5.658C1.885 5.013 2.345 4 3.204 4h9.592a1 1 0 0 1 .753 1.659l-4.796 5.48a1 1 0 0 1-1.506 0z" })
], -1)
const _hoisted_87 = [
  _hoisted_85,
  _hoisted_86
]
const _hoisted_88 = {
  key: 7,
  class: "border-top border-light pt-3 mt-3"
}
const _hoisted_89 = /*#__PURE__*/_createElementVNode("h3", { class: "offer-title" }, "Representativt Exempel", -1)
const _hoisted_90 = { class: "offer-description" }
const _hoisted_91 = /*#__PURE__*/_createElementVNode("p", null, " Observera att vi enligt lag behöver visa detta exempel. Det är inte de lånevillkor som du har fått. ", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_tooltip = _resolveComponent("tooltip")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: _normalizeClass(["card card-feat", { 'content-card-npb': _ctx.expanded }])
    }, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("img", {
                class: "img-fluid",
                src: _ctx.offer.bank.offerImage
              }, null, 8, _hoisted_6),
              (_ctx.showRenewal)
                ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                    (!_ctx.isPastDueDate && _ctx.offer.offerDueDateTextType != null)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                          _createTextVNode(_toDisplayString(_ctx.getOfferDueDateText) + " Förslaget är giltigt i ", 1),
                          _createElementVNode("strong", null, _toDisplayString(_ctx.daysLeftUntilDueDate), 1),
                          _hoisted_9
                        ]))
                      : (!_ctx.isPastDueDate && _ctx.offer.offerDueDateTextType == null)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                            _createTextVNode(_toDisplayString(_ctx.app.purpose == "Renegotiate" ? 'Ditt ränteförslag är giltigt i' : 'Ditt lånelöfte är giltigt i') + " ", 1),
                            _createElementVNode("strong", null, _toDisplayString(_ctx.daysLeftUntilDueDate), 1),
                            _hoisted_11
                          ]))
                        : (_openBlock(), _createElementBlock("div", _hoisted_12, _toDisplayString(_ctx.app.purpose == "Renegotiate" ? 'Ditt ränteförslag har löpt ut' : 'Ditt lånelöfte har löpt ut'), 1))
                  ]))
                : _createCommentVNode("", true),
              _hoisted_13
            ])
          ]),
          (!_ctx.isPastDueDate || !_ctx.showRenewal)
            ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                _createElementVNode("div", {
                  class: "card-content",
                  onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.expanded = !_ctx.expanded))
                }, [
                  _createElementVNode("div", _hoisted_15, [
                    _hoisted_16,
                    _createElementVNode("div", _hoisted_17, [
                      _createElementVNode("strong", null, _toDisplayString(_ctx.formatMoney(_ctx.offer.approvedAmount)) + " kr", 1)
                    ])
                  ]),
                  (_ctx.offer.privateLoanApprovedAmount)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
                        _hoisted_19,
                        _createElementVNode("div", _hoisted_20, [
                          _createElementVNode("strong", null, _toDisplayString(_ctx.formatMoney(_ctx.offer.privateLoanApprovedAmount)) + " kr ", 1)
                        ])
                      ]))
                    : _createCommentVNode("", true),
                  _createElementVNode("div", _hoisted_21, [
                    _hoisted_22,
                    _createElementVNode("div", _hoisted_23, [
                      _createElementVNode("strong", null, _toDisplayString(_ctx.formatMoney(_ctx.offer.monthlyInstallment)) + " kr ", 1)
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_24, [
                    _hoisted_25,
                    _createElementVNode("div", _hoisted_26, [
                      _createElementVNode("strong", null, _toDisplayString(_ctx.offer.interestRate != null
                        ? _ctx.formatDecimal(_ctx.offer.interestRate)
                        : "") + " % ", 1)
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_27, [
                    _hoisted_28,
                    _createElementVNode("div", _hoisted_29, [
                      _createElementVNode("strong", null, _toDisplayString(_ctx.offer.interestRate != null
                        ? _ctx.formatDecimal(_ctx.offer.effectiveRate)
                        : "") + " % ", 1)
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_30, [
                    _hoisted_31,
                    _createElementVNode("div", _hoisted_32, [
                      _createElementVNode("strong", null, _toDisplayString(_ctx.formatMoney(_ctx.offer.amortizationPayment)) + " kr", 1)
                    ])
                  ])
                ]),
                (_ctx.expanded)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_33, [
                      _createElementVNode("div", _hoisted_34, [
                        _hoisted_35,
                        _createElementVNode("div", _hoisted_36, [
                          _createElementVNode("strong", null, _toDisplayString(_ctx.formatMoney(_ctx.offer.interestPayment)) + " kr", 1)
                        ])
                      ]),
                      (_ctx.offer.discountRateMonthlyInstallment)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_37, [
                            _hoisted_38,
                            _createElementVNode("div", _hoisted_39, [
                              _createElementVNode("strong", null, _toDisplayString(_ctx.formatMoney(_ctx.offer.discountRateMonthlyInstallment)) + " kr", 1),
                              _createVNode(_component_tooltip, { title: "Kalkylränta är en räntesats som banker och långivare räknar på vid bolåneansökningar för att säkerställa att bolånekunder kan klara av en högre kostnad om räntorna skulle höjas." })
                            ])
                          ]))
                        : _createCommentVNode("", true),
                      _createElementVNode("div", _hoisted_40, [
                        _hoisted_41,
                        _createElementVNode("div", _hoisted_42, [
                          _createElementVNode("strong", null, _toDisplayString(_ctx.offer.paybackYearsFixed
                        ? _ctx.offer.paybackYearsFixed.toLocaleString()
                        : _ctx.bindingPeriod(_ctx.offer.interestBindingPeriod)) + " mån ", 1)
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_43, [
                        _hoisted_44,
                        _createElementVNode("div", _hoisted_45, [
                          _createElementVNode("strong", null, _toDisplayString(_ctx.offer.arrangementFee) + " kr", 1)
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_46, [
                        _hoisted_47,
                        _createElementVNode("div", _hoisted_48, [
                          _createElementVNode("strong", null, _toDisplayString(_ctx.offer.administrationFee) + " kr", 1)
                        ])
                      ])
                    ]))
                  : _createCommentVNode("", true)
              ]))
            : _createCommentVNode("", true),
          (!_ctx.isPastDueDate || !_ctx.showRenewal)
            ? (_openBlock(), _createElementBlock("div", _hoisted_49, [
                _createElementVNode("div", {
                  onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.expanded = !_ctx.expanded)),
                  class: "card-btn"
                }, [
                  (!_ctx.expanded)
                    ? (_openBlock(), _createElementBlock("button", _hoisted_50, _hoisted_52))
                    : (_openBlock(), _createElementBlock("button", _hoisted_53, _hoisted_55))
                ])
              ]))
            : _createCommentVNode("", true),
          (_ctx.isPastDueDate && _ctx.showRenewal)
            ? (_openBlock(), _createElementBlock("div", _hoisted_56, [
                _createElementVNode("button", {
                  onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.createRenewalUrl && _ctx.createRenewalUrl(...args))),
                  class: "btn btn-primary"
                }, " Förnya lånelöfte ")
              ]))
            : _createCommentVNode("", true)
        ]),
        _createVNode(_Transition, { name: "slide" }, {
          default: _withCtx(() => [
            (_ctx.expanded)
              ? (_openBlock(), _createElementBlock("div", {
                  key: 0,
                  class: "row",
                  onClick: _cache[5] || (_cache[5] = _withModifiers(() => {}, ["stop"]))
                }, [
                  _createElementVNode("div", _hoisted_57, [
                    _createElementVNode("div", _hoisted_58, [
                      (_ctx.missingDocumentSkandia(_ctx.offer.status, _ctx.offer.bank.name))
                        ? (_openBlock(), _createElementBlock("div", _hoisted_59, _hoisted_61))
                        : (_ctx.offerIsSelected(_ctx.offer.id))
                          ? (_openBlock(), _createElementBlock("div", _hoisted_62, _hoisted_64))
                          : (_openBlock(), _createElementBlock("div", _hoisted_65, [
                              _createElementVNode("div", _hoisted_66, [
                                _createElementVNode("div", _hoisted_67, [
                                  _createElementVNode("button", {
                                    onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.submitSelectOffer(_ctx.offer.id))),
                                    class: "btn btn-primary"
                                  }, " Välj " + _toDisplayString(_ctx.bankName), 1)
                                ])
                              ])
                            ])),
                      (!_ctx.offer.possibleInterestRatesWithoutDiscount && _ctx.offer.possibleInterestRates && _ctx.offer.possibleInterestRates.length > 0)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_68, [
                            _hoisted_69,
                            _createElementVNode("div", _hoisted_70, [
                              _createElementVNode("table", _hoisted_71, [
                                _hoisted_72,
                                _createElementVNode("tbody", null, [
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.offer.possibleInterestRates, (item) => {
                                    return (_openBlock(), _createElementBlock("tr", { key: item }, [
                                      _createElementVNode("td", null, _toDisplayString(_ctx.translateBindinPeriod(item.bindingPeriod)), 1),
                                      _createElementVNode("td", null, _toDisplayString(item.interestRateBeforeDiscount) + " %", 1),
                                      _createElementVNode("td", null, _toDisplayString(_ctx.addMinuSign(item.discount)) + " %", 1),
                                      _createElementVNode("td", null, [
                                        _createElementVNode("strong", null, _toDisplayString(item.interestRateAfterDiscount) + " %", 1)
                                      ])
                                    ]))
                                  }), 128))
                                ])
                              ])
                            ])
                          ]))
                        : _createCommentVNode("", true),
                      (_ctx.offer.possibleInterestRatesWithoutDiscount && _ctx.offer.possibleInterestRates && _ctx.offer.possibleInterestRates.length > 0)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_73, [
                            _hoisted_74,
                            _createElementVNode("div", _hoisted_75, [
                              _createElementVNode("table", _hoisted_76, [
                                _hoisted_77,
                                _createElementVNode("tbody", null, [
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.offer.possibleInterestRates, (item) => {
                                    return (_openBlock(), _createElementBlock("tr", { key: item }, [
                                      _createElementVNode("td", null, _toDisplayString(_ctx.translateBindinPeriod(item.bindingPeriod)), 1),
                                      _createElementVNode("td", null, [
                                        _createElementVNode("strong", null, _toDisplayString(item.interestRateAfterDiscount) + " %", 1)
                                      ])
                                    ]))
                                  }), 128))
                                ])
                              ])
                            ])
                          ]))
                        : _createCommentVNode("", true),
                      (_ctx.offer.bank.offerAdditions)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_78, [
                            _hoisted_79,
                            _createElementVNode("div", _hoisted_80, [
                              _createElementVNode("p", null, _toDisplayString(_ctx.offer.bank.offerAdditions), 1)
                            ])
                          ]))
                        : _createCommentVNode("", true),
                      (_ctx.offer.bank.introDescription)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_81, [
                            _hoisted_82,
                            _createElementVNode("div", _hoisted_83, [
                              _createElementVNode("p", null, _toDisplayString(_ctx.offer.bank.introDescription), 1),
                              _withDirectives(_createElementVNode("p", null, [
                                (_ctx.headerExpandDescription)
                                  ? (_openBlock(), _createElementBlock("span", _hoisted_84, _toDisplayString(_ctx.offer.bank.expandedDescription), 1))
                                  : _createCommentVNode("", true),
                                (!_ctx.headerExpandDescription)
                                  ? (_openBlock(), _createElementBlock("a", {
                                      key: 1,
                                      href: "#",
                                      class: "btn btn-xs btn-outline",
                                      onClick: _cache[4] || (_cache[4] = _withModifiers(($event: any) => (_ctx.headerExpandDescription = true), ["prevent"]))
                                    }, _hoisted_87))
                                  : _createCommentVNode("", true)
                              ], 512), [
                                [_vShow, 
                        _ctx.offer.bank.expandedDescription != null &&
                        _ctx.offer.bank.expandedDescription != ''
                      ]
                              ])
                            ])
                          ]))
                        : _createCommentVNode("", true),
                      (_ctx.offer.bank.representativeText)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_88, [
                            _hoisted_89,
                            _createElementVNode("div", _hoisted_90, [
                              _hoisted_91,
                              _createElementVNode("p", null, _toDisplayString(_ctx.offer.bank.representativeText), 1)
                            ])
                          ]))
                        : _createCommentVNode("", true)
                    ])
                  ])
                ]))
              : _createCommentVNode("", true)
          ]),
          _: 1
        })
      ])
    ], 2)
  ]))
}